export default __webpack_public_path__ + "static/media/shipment-activity-delivery.1832bb73.svg";